import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { FormattedMessage } from "react-intl";
import CreateTeacherForm from "../Forms/CreateTeacherForm";

class CreateTeacher extends React.Component {
  render() {
    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle}>
        <ModalHeader>
          <FormattedMessage id={this.props.teacherToUpdate ? "UpdateTeacher" : "CreateTeacher"} />
        </ModalHeader>
        <ModalBody>
          <CreateTeacherForm
            teacherToUpdate={this.props.teacherToUpdate}
            loadTeachers={this.props.loadTeachers}
            dismissModal={this.props.toggle}
            schoolClasses={this.props.schoolClasses}
            simpleCreate={!this.props.fullAccess}
          />
        </ModalBody>
      </Modal>
    );
  }
}

export default CreateTeacher;
